import { CRUDBasicListComponent } from '../crud-basic-list/crud-basic-list.component';
//import { CRUDBasicListComponent_Template, CRUDBasicListComponent } from '../crud-basic-list/crud-basic-list.component'; // HTML Template Plugins
//import { DienstleisterListComponent_Template } from './dienstleister-list.component.include_template'; // HTML Template Plugins

import { Component, OnInit, Inject, forwardRef, Injector } from '@angular/core';

import { ApplicationRef, ComponentRef, ChangeDetectorRef } from '@angular/core'; // für's dynamische Einfügen von ng-Components - siehe ngAfterViewInit
import { Checkbox } from 'primeng/checkbox'; // für's dynamische Einfügen von ng-Components - siehe ngAfterViewInit

import { Table } from 'primeng/table';

import { AppComponent } from '../app.component';

//import { IDienstleister } from '../_interfaces/dienstleister';
import { DienstleisterService } from '../_services/dienstleister.service';

@Component({
  selector: 'app-dienstleister-list',
  templateUrl: '../crud-basic-list/crud-basic-list.component.html',
  //templateUrl: './dienstleister-list.component.html',
  //template: `${CRUDBasicListComponent_Template || ''}${DienstleisterListComponent_Template}`,  // HTML Template Plugins
  styleUrls: ['../crud-basic-list/crud-basic-list.component.css'],
  host: {
    '(window:keydown)': 'hotkeys($event)',
    '(window:resize)': 'sizeTable()'
  }
})
export class DienstleisterListComponent extends CRUDBasicListComponent implements OnInit {
  pageTitle: string = this.translate.instant("Dienstleister", true);
  CRUDItemKurzform: string = "Dienstleister";
  CRUDItemButtonTitleNeu: string = this.translate.instant("Neuer Dienstleister", true);
  CRUDItemBezeichnungSingularCapitalized: string = "Dienstleister";
  CRUDItemBezeichnungPluralCapitalized: string = "Dienstleister";
  CRUDItemBezeichnungSingular: string = "dienstleister";
  CRUDItemBezeichnungPlural: string = "dienstleister";
  CRUDItemHelpTopic: string = null;
  CRUDItemRouteSingular: string = "dienstleister";
  CRUDItemRoutePlural: string = "dienstleister";

  CRUDDisableLoeschen: boolean = true; // s.u.: dafür aktivieren/deaktivieren

  CRUDMethodNameGetCollection: string = "getDienstleisterCollectionBare"; // Alternative Methode (im Service), die bei getCollection aufgerufen werden soll
                                                                          // ACHTUNG! wird in getCRUDItems() dynamisch überschrieben, je nachdem, ob inaktive mit angezeigt werden sollen, oder nicht
  CRUDMethodNameDelete: string = "deactivateDienstleister"; // Alternative Methode (im Service), die bei delete aufgerufen werden soll
  
  // dynamisch Checkbox "inaktive anzeigen" einfügen
  CRUDTemplatePluginTop = document.createElement("div"); // siehe ngAfterViewInit
  inaktiveCheckbox: HTMLInputElement = null;

  CRUDItemAvailableCols: any[] = [
          {
            field: 'createdBy',
            header: this.translate.instant('CreatedBy', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 10,
            showByDefault: false
          },
          {
            field: 'created',
            header: this.translate.instant('Created', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 20,
            showByDefault: false
          },
          {
            field: 'modifiedBy',
            header: this.translate.instant('ModifiedBy', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 30,
            showByDefault: false
          },
          {
            field: 'modified',
            header: this.translate.instant('Modified', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 40,
            showByDefault: false
          },
          {
            field: 'bezeichnung',
            header: this.translate.instant('Name', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 50,
            showByDefault: true
          },
          {
            field: 'strasse',
            header: this.translate.instant('Strasse', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 52,
            showByDefault: true
          },
          {
            field: 'plz',
            header: this.translate.instant('Postleitzahl', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 54,
            showByDefault: true
          },
          {
            field: 'ort',
            header: this.translate.instant('Ort', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 56,
            showByDefault: true
          },
          {
            field: 'ortzusatz',
            header: this.translate.instant('Ortszusatz', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 58,
            showByDefault: true
          },
          {
            field: 'email',
            header: this.translate.instant('E-Mail', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 60,
            showByDefault: true
          },
          {
            field: 'zuordnung',
            header: this.translate.instant('Zuordnung', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 70,
            showByDefault: true
          },/*
          {
            field: 'benutzer',
            header: this.translate.instant('Benutzer', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 80,
            showByDefault: true
          },
          {
            field: 'kopfdaten',
            header: this.translate.instant('Kopfdaten', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 90,
            showByDefault: true
          }*/
          /*{
            field: 'spediteur',
            header: this.translate.instant('Spediteur', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 80,
            showByDefault: true
          }*/
          {
            field: 'inaktiv',
            header: this.translate.instant('Inaktiv', true),
            styleClass: 'columnText',
            sortable: true,
            filterMatchMode: "contains",
            order: 90,
            showByDefault: true,
            nullable: true
          },
    ];

    constructor(
      @Inject(forwardRef(() => AppComponent)) public _app: AppComponent,
      private _crudItemService: DienstleisterService,
      private _injector: Injector,
      private _appRef: ApplicationRef,
      private _changeDetectorRef: ChangeDetectorRef,
    ) {
      super(_app, _injector);
      this.crudItemService = _crudItemService;
    }

    //ngOnInit() { // HTML Template Plugins
    //  super.ngOnInit();
    //  this.app.pageTitle = this['pageTitle'];
    //}

    ngAfterViewInit() {
      console.log("DienstleisterList.ngAfterViewInit()");
      // in CRUDTemplatePluginTop dynamisch eine CheckBox "inaktive anzeigen" einfügen
      this.CRUDTemplatePluginTop.style.backgroundColor = "white";
      this.CRUDTemplatePluginTop.style.textAlign = "right";
      this.CRUDTemplatePluginTop.style.width = "100%";
      this.CRUDTemplatePluginTop.style.height = "3em";

      let crudDataTable = document.getElementById("crudDataTable");
      let parent = crudDataTable.parentNode;
      parent.insertBefore(this.CRUDTemplatePluginTop, crudDataTable);

      // dynamisches einfügen einer Checkbox - plain JS, weil ng 13 weder ComponentFactoryResolver noch createComponent verfügbar
      // 1. Erstelle eine neue Checkbox
      this.inaktiveCheckbox = document.createElement("input");
      this.inaktiveCheckbox.type = "checkbox";
      this.inaktiveCheckbox.style.transform = "scale(1.5)";
      this.inaktiveCheckbox.id = "_inaktiveCheckbox";

      // 2. Erstelle ein Label für die Checkbox
      let label = document.createElement("label");
      label.htmlFor = "_inaktiveCheckbox";
      label.style.marginLeft = "1.5em";
      label.style.marginRight = "1em";
      label.textContent = this.translate.instant("Inaktive anzeigen", true);

      // 3. Füge Checkbox und Label in den Container ein
      let checkboxContainer = this.CRUDTemplatePluginTop;
      checkboxContainer.appendChild(document.createElement("br"));
      checkboxContainer.appendChild(this.inaktiveCheckbox);
      checkboxContainer.appendChild(label);
 
      // 4. Überprüfe den Wert der Checkbox
      /*this.inaktiveCheckbox.addEventListener("change", function() {
        if (this.inaktiveCheckbox.checked) {
          console.log("Checkbox ist aktiviert!");
        } else {
          console.log("Checkbox ist deaktiviert!");
        }
      });*/


      // Löschen-Button, Aktivieren Button einfügen - werden dyn. bei dropdownClicked() aktiviert/deakt.
      this.buttonItems.push(
        {
          id: 'deactivate', label: this.translate.instant('Deaktivieren', true), icon: 'fa fa-trash', automationId: 30, command: (res) => {
            this._deactivateCRUDItem(this.selectedCrudItem);
          }
        }
      );

      this.buttonItems.push(
        {
          id: 'activate', label: this.translate.instant('Aktivieren', true), icon: 'fa fa-trash-slash', automationId: 40, command: (res) => {
            this._activateCRUDItem(this.selectedCrudItem);
          }
        }
      );
    }

    getCRUDItems() { // overwrite:
      console.log("CRUDBasicList.DienstleisterList()");
      // je nachdem, ob inaktive angezeigt werden sollen oder nicht, entspr. get-methode setzen:
      if(this.inaktiveCheckbox.checked) {
        this.CRUDMethodNameGetCollection = "getDienstleisterCollectionBareIncludingInactive";
      }
      else {
        this.CRUDMethodNameGetCollection = "getDienstleisterCollectionBare";
      }

      super.getCRUDItems();
    }

    //Wenn der Splitbutton geklickt wird (der DropdownPfeil des Einstellungen Buttons) bzw direkt drauf.
    //Speichert aktuell geklickte User Informationen
    dropdownClicked(CRUDItem: /*ITitel*/any) { // obverwrite !!!
      super.dropdownClicked(CRUDItem);
      this._refreshMoreMenu();
    }


    _refreshMoreMenu() {
      console.log("DienstleisterList._refreshMoreMenu()");
      let _deactivateButton = this.buttonItems.filter(f => f.id == 'deactivate')[0];
      let _activateButton = this.buttonItems.filter(f => f.id == 'activate')[0];
      if(this.selectedCrudItem.inaktiv == true) {
        _deactivateButton.disabled = true;
        delete _activateButton.disabled;
      }
      else {
        delete _deactivateButton.disabled;
        _activateButton.disabled = true;
      }
    }

    _activateCRUDItem(CRUDItem: /*ITitel*/any) { // Overwrite ...
      this.confirmationService.confirm({
        message: this.translate.instant('Wollen Sie den Dienstleister wieder aktivieren?', true) + '?',
        header: this.translate.instant('Aktivieren', true) + '?',
        icon: 'fa fa-trash',
        key: 'CRUDBasicListConfirmDialog_' + this.CRUDItemBezeichnungPluralCapitalized,
        accept: () => {
          this.loading = true;
          this.crudItemService.activateDienstleister(CRUDItem.id)
          .subscribe(
            res => {
              this.loading = false;
              this.refreshRow(CRUDItem.id);
              this.messageWrapperService.postTimedMessage({ severity: 'success', summary: this.translate.instant("Aktivierung erfolgreich", true), detail: CRUDItem.bezeichnung })
            },
            (error: any) => {
              this.handleError(error);
            }
          );
        },
        reject: () => {
        }
      });
    }

    _deactivateCRUDItem(CRUDItem: /*ITitel*/any) { // Overwrite ...
        this.confirmationService.confirm({
          message: this.translate.instant('Wollen Sie den Dienstleister deaktivieren?', true) + '?',
          header: this.translate.instant('Deaktivieren', true) + '?',
          icon: 'fa fa-trash',
          key: 'CRUDBasicListConfirmDialog_' + this.CRUDItemBezeichnungPluralCapitalized,
          accept: () => {
            this.loading = true;
            this.crudItemService.deactivateDienstleister(CRUDItem.id)
            .subscribe(
              res => {
                this.loading = false;
                this.refreshRow(CRUDItem.id);
                this.messageWrapperService.postTimedMessage({ severity: 'success', summary: this.translate.instant("Deaktivierung erfolgreich", true), detail: CRUDItem.bezeichnung })
              },
              (error: any) => {
                this.handleError(error);
              }
            );
          },
          reject: () => {
          }
        });
    }

}
